import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import '../styles/styles.css';
import '../styles/nav.css';
import { getEvaluations, deleteEva,patchEva } from '../services/api';
import { useServerPagination } from '../utils/serverPag';
import { confirmar } from './ConfirmModal';
import { toast } from 'react-toastify';

const ListarEvaluaciones = () => {
  const [sortField, setSortField] = useState('fecha');
  const [sortOrder, setSortOrder] = useState('desc');
  const [searchEmpresa, setSearchEmpresa] = useState('');
  const [searchPaciente, setSearchPaciente] = useState('');
  
  const fetchFn = useCallback(
    (opts) => getEvaluations({
      ...opts,
      sort: sortField,
      order: sortOrder
    }),
    [sortField, sortOrder]
  );

  const {
    items: evaluaciones,
    page,
    total,
    totalPages,
    loading,
    error,
    setPage,
    refresh
  } = useServerPagination(fetchFn, { initialPerPage: 10 });

  const handleSort = (field) => {
    const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';
    setSortField(field);
    setSortOrder(order);
    refresh(); // recarga con nuevo sort
  };

  const handleDelete = async (id_eva, nombrePaciente) => {
    const confirmed = await confirmar(`¿Estás seguro de eliminar la evaluacion de "${nombrePaciente}" ?`, { variante: 'peligro' });
    if (!confirmed) return;
    try {
      await deleteEva(id_eva);
      toast.success('evaluacion eliminada correctamente');
      refresh();
    } catch (error) {
      console.error('Error al eliminar evaluación:', error);
      if (error.response?.status === 409) {
        toast.error("No se puede eliminar: evaluacion ya tiene examenes asociados");
      } else {
        toast.error("No se pudo eliminar la evaluación.");
      }
    }
  }
  const handleTogglePendiente = async (ev) =>{
    const nuevoEstado = !ev.pendiente;
    const nombreCompleto = `${ev.nombre_paciente ?? ''} ${ev.apellido_paciente ?? ''}`.trim();
    const mensaje = nuevoEstado
      ? `¿Estás seguro de marcar la evaluación de "${nombreCompleto}" como PENDIENTE?`
      : `¿Estás seguro de desmarcar la evaluación de "${nombreCompleto}" de PENDIENTE?`;
    if (!(await confirmar(mensaje))) return;
    try {
      await patchEva(ev.id_eva,{pendiente: nuevoEstado});
      refresh();
    }catch(error){
      console.error("Error al actualizar estado pendiente:", error);
      toast.error("No se pudo cambiar el estado pendiente");
    }
  };
// para que el filtro funcione al apretar el boton de filtrar se hizo lo mismo que en listar paciente
// osea se entregan los parametros en el handlesearch y llama a refresh con paciente y empresa
  const handleSearch = () => {
    setPage(1);
    refresh({empresa:searchEmpresa,paciente:searchPaciente});
  };
  const getRowClassName = (ev) => {
    if (ev.pendiente) return "evaluacion-pendiente";
    if (ev.revisado) return "evaluacion-revisada";
    return "";
  };

  return (
    <div>
      <div className="content-wrapper">
        <h1>Lista de Evaluaciones</h1>
        <div className="container">
          <form className="form-search">
            <div className="form-block">
              <label htmlFor="empresa">Buscar por Empresa:</label>
              <input
                type="text"
                id="empresa"
                className="form-control"
                placeholder="Ingresa nombre de empresa"
                value={searchEmpresa}
                onChange={(e) => setSearchEmpresa(e.target.value)}
              />
            </div>

            <div className="form-block">
              <label htmlFor="paciente">Buscar por Paciente:</label>
              <input
                type="text"
                id="paciente"
                className="form-control"
                placeholder="Ingresa nombre y/o apellido"
                value={searchPaciente}
                onChange={(e) => setSearchPaciente(e.target.value)}
              />
            </div>

            <button type="button" className="btn-create" onClick={handleSearch}>
              Buscar
            </button>
          </form>
        </div>


        {loading && <div>Loading evaluaciones...</div>}
        {error && <div className="error">Error cargando evaluaciones</div>}

        <div className="container">
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th className="sortable" onClick={() => handleSort('nombre_paciente')}>
                    Paciente {sortField === 'nombre_paciente' && (sortOrder === 'asc' ? '▲' : '▼')}
                  </th>
                  <th className="sortable" onClick={() => handleSort('fecha')}>
                    Fecha {sortField === 'fecha' && (sortOrder === 'asc' ? '▲' : '▼')}
                  </th>
                  <th className='sortable' onClick={()=> handleSort('nombre_empresa')} >
                    Empresa {sortField === 'nombre_empresa' && (sortOrder === 'asc' ? '▲' : '▼')}
                  </th>
                  <th>Batería</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {evaluaciones.map((ev) => (
                  <tr key={ev.id_eva} className={getRowClassName(ev)}>
                    <td>{`${ev.nombre_paciente ?? ''} ${ev.apellido_paciente ?? ''}`}</td>
                    <td>{ev.fecha ? ev.fecha.split('-').reverse().join('/') : ''}</td>
                    <td>{ev.nombre_empresa ?? 'Sin empresa'}</td>
                    <td>{ev.nombres_bat && ev.nombres_bat.length > 0 ? ev.nombres_bat[0] : 'Sin bateria'}</td>
                    <td>
                      <div className="btn-group" style={{ flexDirection: 'column' }}>
                        <Link to={`/evaluaciones/editar/${ev.id_eva}`} className="btn-create">
                          Editar
                        </Link>
                        <Link to={`/evaluaciones/${ev.id_eva}/examenes`} className="btn-secondary" >
                          Examenes
                        </Link>
                        <button
                          type="button"
                          className="btn-danger"
                          onClick={() => handleDelete(ev.id_eva, ev.nombre_paciente)}
                        >
                          Eliminar
                        </button>
                        {ev.revisado && (
                          <label className="checkbox-pendiente" style={{ marginTop: '6px', fontSize: '0.85rem' }}>
                            <input
                              type="checkbox"
                              checked={!!ev.pendiente}
                              onChange={() => handleTogglePendiente(ev)}
                            />
                            Pendiente
                          </label>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>

            </table>
          </div>
        </div>

        <div className="pagination-controls">
          <button onClick={() => setPage(page - 1)} disabled={page <= 1 || loading}>Prev</button>
          <span> Página {page} de {totalPages} — {total} evaluaciones</span>
          <button onClick={() => setPage(page + 1)} disabled={page >= totalPages || loading}>Next</button>
        </div>
      </div>
    </div>
  );
};

export default ListarEvaluaciones;
